//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import DistrictForm from 'features/forms/admin/District';
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentOrg } from 'store/organizations/selectors';
import { handleGetOrgPermissionPermission } from "store/organizations/thunks";
import get from "lodash/get"
import SpinLoader from 'components/Loader/SpinLoader';
import SentryWrap from 'components/Sentry';
import { initialPermissions } from 'utils/config/reference';

const StableWrapperMain = styled.div`
    margin-top:10px;
`;

const AddDistricts = ({ }) => {
    const location = useLocation();
    const currentOrg = useCurrentOrg()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const districtInfo = useMemo(() => get(location.state, 'userData', null), [location.state])
    const [loading, setLoader] = useState(false)
    const [permissions, setPermissions] = useState(initialPermissions)
    const loadPermission = async () => {
        try {
            if (districtInfo && districtInfo.id) {
                setLoader(true);
                const response = await dispatch(handleGetOrgPermissionPermission(districtInfo.id));
                if (response && response.id) {
                    setPermissions(response)
                }
            }
        } catch (error) {

        } finally {
            setLoader(false)
        }
        //  const resp = permissions;
        //             const distPermissions = get(district, "permissions", null);
        //             if (distPermissions) {
        //                 setPermissions(distPermissions)
        //             } else {
        //                 setPermissions(resp)
        //             }
    }

    useEffect(() => {
        loadPermission()

    }, [districtInfo])

    const backToDataBrowser = () => {
        navigate('/data-browsers?tab=district');
    };

    return (
        <SentryWrap>
            <SpinLoader dataloader={loading} />
            <Row>
                <Col lg={24}>
                    <Button type="link" primary style={{ paddingLeft: 0, fontSize: 17, marginBottom: 20 }} onClick={backToDataBrowser}>
                        <ArrowLeftOutlined />
                        Back
                    </Button>
                </Col>
            </Row>
            <StableWrapperMain>
                <DistrictForm
                    district={districtInfo}
                    editing={districtInfo && districtInfo.id}
                    org_permission={permissions}
                    onClose={() => {
                        
                    }}
                />
            </StableWrapperMain>
        </SentryWrap>
    );
};



export default AddDistricts;
